import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular-ivy";
import { AppModule } from './app/app.module';
import { AppConfigModule } from './app/app-config.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://fcfe979d4ac444588c564344c33d8132@sentry.salamek.cz/45",
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    new Sentry.Replay(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.7,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/swissknife-api.nextbike\.cz/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const currentLocation = window.location.href;
let configIdentifier = environment.name;
let currentHostname: string;

if (currentLocation) {
  const parsedCurrentLocation = new URL(currentLocation);
  const configNamespace = parsedCurrentLocation.searchParams.get('config.namespace');
  if (configNamespace) {
    configIdentifier = `${configNamespace}.${environment.name}`;
  }

  currentHostname = parsedCurrentLocation.hostname;
}


fetch(`/config/config.${configIdentifier}.json`).then(resp => resp.json()).then(config => {
  if (currentHostname) {
    config.apiEndpoint = config.apiEndpoint.replace('CURRENT_HOSTNAME', currentHostname);
    config.graphqlEndpoint = config.graphqlEndpoint.replace('CURRENT_HOSTNAME', currentHostname);
  }
  const appConfigModule = new AppConfigModule(config);
  platformBrowserDynamic([{ provide: AppConfigModule, useValue: appConfigModule }]).bootstrapModule(AppModule)
    .catch(err => console.error(err));
});


